import React from "react";
import { Button, Grid, TextField, Typography, Link } from "@mui/material";
import colors from "../../../../colors";
import ButtonGroup from "../../../../general/ButtonGroup";
import {
  selectUtilityState,
  setSentFrom,
} from "../../../../../features/utilities/utilitySlice";
import { useSelector, useDispatch } from "react-redux";
import { determineUtilityRequest } from "../DetermineUtilityRequest";
import { makeStyles } from "@mui/styles";
import { selectUserInfo } from "../../../../../features/userInfo/userInfoSlice";
import {
  selectMyContractsState,
  setShouldFillFields,
} from "../../../../../features/myContracts/myContractsSlice";
import { useNavigate } from "react-router-dom";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import { texts } from "../../../../general/texts";

export const Qezhef = (props) => {
  const dispatch = useDispatch();
  const userInfo = useSelector(selectUserInfo);
  const utilitySliceState = useSelector(selectUtilityState);
  const myContractsSliceState = useSelector(selectMyContractsState);
  const navigate = useNavigate();

  const searchMethods = [
    { display: texts["title-client-code"], value: "1" },
    { display: texts["title-serie"], value: "2" },
  ];

  const [state, setState] = React.useState({
    utilityName: props.utilityName,
    selectedSearchMethod: searchMethods[0].value,
    token: props.globalDataSliceState.token,
    serie: "",
    clientCode: "",
  });

  const getSearchMethodValue = (value) => {
    setState({ ...state, selectedSearchMethod: value });
  };

  const handleButtonClick = (sentFrom) => {
    dispatch(utilityRequest);
    dispatch(setSentFrom(sentFrom));
  };

  const handleTextFieldChange = (prop) => (e) => {
    setState({
      ...state,
      [prop]: e.target.value,
    });
  };

  const utilityRequest = determineUtilityRequest(state);

  const selectedButtonStyle = {
    backgroundColor: colors.lightOrange,
    color: colors.orange,
    width: "150px",
    height: "40px",
    fontFamily: "GerberaBold",
    textTransform: "none",
    fontSize: "1rem",
    border: "2px solid" + colors.orange,
    borderRadius: "10px",
    "&:hover": {
      backgroundColor: colors.lightOrange,
    },
    "@media (max-width: 899px)": { width: "130px", height: "40px" },
  };

  const defaultButtonStyle = {
    backgroundColor: colors.lightBlue,
    width: "150px",
    height: "40px",
    borderRadius: "10px",
    textTransform: "none",
    fontFamily: "GerberaLight",
    fontSize: "1rem",
    color: colors.darkBlue,
    "&:hover": {
      backgroundColor: colors.lightOrange,
    },
    "@media (max-width: 899px)": { width: "130px", height: "40px" },
  };

  React.useEffect(() => {
    if (myContractsSliceState.shouldFillFields) {
      setState({
        ...state,
        clientCode: props.selectedContractInfo.contract,
      });
      dispatch(setShouldFillFields(false));
    }
  }, [myContractsSliceState.shouldFillFields]);

  const useStyles = makeStyles({
    mainGrid: {
      padding: "5%",
      paddingTop: "3%",
    },
    utilityName: {
      color: props.utilityInfo.Color,
      fontSize: "1.5rem",
      fontFamily: "GerberaBold",
      paddingTop: "3%",
      paddingLeft: "2%",
    },
    headerBox: {
      backgroundColor: colors.cyan,
      borderRadius: "100%",
      width: "70px",
      height: "70px",
    },
    fieldTitle: {
      color: colors.darkBlue,
      fontSize: "1.2rem",
      fontFamily: "GerberaBold",
      textAlign: "left",
    },
    button: {
      width: "100%",
      color: colors.white,
      fontSize: "1rem",
      textTransform: "none",
      background: colors.gradientOrange,
      fontFamily: "GerberaBold",
    },
    buttonGrid: {
      marginTop: 150,
      paddingBottom: 5,
    },
    image: {
      width: "70%",
    },
    textField: {
      width: "100%",
    },
  });
  const classes = useStyles();

  return (
    <Grid container item className={classes.mainGrid} rowSpacing={3}>
      <Grid container item md={2} xs={2} mt={2}>
        <Link
          component={"button"}
          onClick={() => {
            navigate(-1);
          }}
        >
          <ArrowBackIosNewIcon color="warning" />
        </Link>
      </Grid>
      <Grid container item md={12} xs={12}>
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
          className={classes.headerBox}
        >
          <img
            src={
              props.utilityInfo.Images.filter(
                (image) => image.color === 1 && image.size === 1
              )[0].imagePath
            }
            className={classes.image}
          />
        </Grid>
        <Typography className={classes.utilityName}>
          {props.utilityInfo.PublicName}
        </Typography>
      </Grid>
      <Grid container item md={12} xs={12}>
        <Typography className={classes.fieldTitle}>
          {texts["prompt-choose-search-method"]}
        </Typography>
      </Grid>
      <Grid
        container
        item
        md={12}
        xs={12}
        justifyContent="flex-start"
        columnSpacing={5}
        rowSpacing={3}
      >
        <ButtonGroup
          defaultButtonStyle={defaultButtonStyle}
          selectedButtonStyle={selectedButtonStyle}
          state={searchMethods}
          sendValue={getSearchMethodValue}
        />
      </Grid>
      {state.selectedSearchMethod === "1" && (
        <Grid container item rowSpacing={3}>
          <Grid item md={12} xs={12}>
            <Typography className={classes.fieldTitle}>
              {texts["title-client-code"]}
            </Typography>
          </Grid>
          <Grid item md={12} xs={12}>
            <TextField
              onChange={handleTextFieldChange("clientCode")}
              value={state.clientCode}
              color="warning"
              size="small"
              label={texts["placeholder-client-code"]}
              className={classes.textField}
            />
          </Grid>
          <Grid item md={12} xs={12} className={classes.buttonGrid}>
            <Button
              disabled={utilitySliceState.isLoading ? true : false}
              onClick={() => {
                handleButtonClick("contractList");
              }}
              className={classes.button}
            >
              {texts["title-search"]}
            </Button>
          </Grid>
        </Grid>
      )}
      {state.selectedSearchMethod === "2" && (
        <Grid container item rowSpacing={3}>
          <Grid item md={12} xs={12}>
            <Typography className={classes.fieldTitle}>
              {texts["title-document-number"]}
            </Typography>
          </Grid>
          <Grid item md={12} xs={12}>
            <TextField
              onChange={handleTextFieldChange("serie")}
              color="warning"
              size="small"
              label={texts["placeholder-document-number"]}
              className={classes.textField}
            />
          </Grid>
          <Grid item md={12} xs={12} className={classes.buttonGrid}>
            <Button
              disabled={utilitySliceState.isLoading ? true : false}
              onClick={() => {
                handleButtonClick("singleInvoice");
              }}
              className={classes.button}
            >
              {texts["title-search"]}
            </Button>
          </Grid>
        </Grid>
      )}
    </Grid>
  );
};
export default Qezhef;
